<div class="space-y-6">
  <app-page-header
    [backTo]="['/operators']"
    backLabel="Retour aux opérateurs"
    title="Nouvel opérateur"
    subtitle="Crée un opérateur pour un utilisateur existant. Démarre en PENDING — passe en ACTIVE via l'action « Approuver » sur sa fiche."
  />

  <section class="rounded-2xl border border-gray-200 bg-white p-6 shadow-theme-xs dark:border-gray-800 dark:bg-white/[0.03]">
    <app-operator-form
      mode="create"
      [submitting]="submitting()"
      [serverError]="serverError()"
      (saveCreate)="onSave($event)"
      (cancel)="onCancel()"
    />
  </section>
</div>
